var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BAutocomplete',_vm._g(_vm._b({ref:"autocomplete",attrs:{"label":"Файл","no-data-text":"Файл не найден","request":_vm.request}},'BAutocomplete',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }